import { Autocomplete, TextField, Typography } from '@mui/material';
import customAxios from '../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../scss/Components/_modal.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { GlobalVariables } from '../../globalVar';
import { getToast } from '../../utils/toastConfig';

function ModalCancelVisit(props) {
  const [visitInfo, setVisitInfo] = useState({});
  const [reason, setReason] = useState('');
  const [isReasonEntered, setIsReasonEntered] = useState(false);

  var cancelVisitClientName = localStorage.getItem('visitClientNameForCancel');
  var cancelVisitSiteName = localStorage.getItem('visitSiteNameForCancel');
  var cancelVisitTypeName = localStorage.getItem('visitTypeNameForCancel');

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Servicio cancelado exitosamente.' });
    setTimeout(() => {
      window.location.reload();
    }, 3600);
  }

  /**
   * Handles reason field onChange
   */
  function handleReasonChange(e) {
    setReason(e.target.value);
    setIsReasonEntered(!!e.target.value);
  }

  const fetchVisit = async () => {
    const endpoint = `${GlobalVariables.getURL()}getVisitById/${props.visitId}`;

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        setVisitInfo(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function cancelVisit() {
    var visit_id = props.visitId;
    customAxios
      .patch(
        `${GlobalVariables.getURL()}cancelVisit/${visit_id}`,
        {
          reason: reason,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      )
      .then(
        (response) => {
          hide();
        },
        (error) => {
          console.log(error);
          getToast({
            status: 'error',
            title: 'Error al cancelar servicio. Vuelve a intentarlo.',
          });
        }
      );
  }

  function hideN() {
    props.onHide();
  }

  useEffect(() => {
    if (!props.show) return;

    fetchVisit();
  }, [props.show]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          ¿Quieres cancelar este servicio?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="cancel-info">
          <strong>Plaza:</strong> {visitInfo.business_name}
        </span>
        <br />
        <span className="cancel-info">
          <strong>Sucursal:</strong> {visitInfo.site_name}
        </span>
        <br />
        <span className="cancel-info">
          <strong>Tipo de servicio:</strong> {visitInfo.failure_type_name}
        </span>
        <br /> <br />
        <TextField
          multiline
          sx={{ width: '100%' }}
          label="Ingresa la razón de cancelación"
          rows={2}
          type="text"
          value={reason}
          onChange={handleReasonChange}
          required
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="modal-button"
          onClick={() => {
            cancelVisit();
          }}
          disabled={!isReasonEntered}
        >
          <FontAwesomeIcon icon={faWarning} /> Si, quiero cancelar.
        </button>
        <button
          className="modal-button no"
          onClick={() => {
            hideN();
          }}
        >
          <FontAwesomeIcon icon={faCircleChevronLeft} /> No, regresar.
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCancelVisit;
